<template>
    <div class="container text-center">
        verifying....
    </div>
</template>
<script>
import api from "@/utils/api";
import store from "@/store"

export default {
    name: "Verify",
    beforeRouteEnter: (to, from, next) => {
        const handleNavigation = function () {
            if (to.query.code) {
                store.commit('auth/recommendationCode', to.query.code)
            }
        
            if (store.getters['auth/hasPendingDeal']) {
            
                next(vm => {
                    vm.$toast.success('Email has been verified!');
                    next({name: 'SetupDeal'})
                });
            } else {
                next(vm => {
                    vm.$toast.success('Email has been verified!');
                    next({name: 'ProfileSettings'})
                });
            }
        }
        
        api.verify(to.params.token).then((accessResponse) => {
            if(store.getters['auth/isUser']){
                store.commit('auth/setVerified');
                handleNavigation();
            } else {
                api.token = accessResponse.data.data.access_token;
                api.profile().then(response => {
                    store.commit('auth/setAccessToken', accessResponse.data.data.access_token);
                    store.commit('auth/setAccessTokenExpiresAt', accessResponse.data.data.expires_at);
                    store.commit('auth/setUser', response.data.data);
                    store.commit('auth/setVerified');
                    handleNavigation();
                })
            }
        }).catch(() => {
            next(vm => {
                vm.$toast.error('Problem with email verification!')
                next({name: 'RegisterDone'})
            });
        });
    }
}
</script>

